import {
  AccessTokenCallback,
  UserLoadedCallback,
  UserManager,
  UserUnloadedCallback,
} from 'oidc-client-ts';
import React from 'react';

type OidcEvents = {
  onAccessTokenExpired?: AccessTokenCallback;
  onAccessTokenExpiring?: AccessTokenCallback;
  onUserLoaded?: UserLoadedCallback;
  onUserUnloaded?: UserUnloadedCallback;
};

export const addOidcEvents = (manager: UserManager | null, events: OidcEvents) => {
  if (events.onAccessTokenExpired)
    manager?.events.addAccessTokenExpired(events.onAccessTokenExpired);
  if (events.onAccessTokenExpiring)
    manager?.events.addAccessTokenExpiring(events?.onAccessTokenExpiring);
  if (events.onUserLoaded) manager?.events.addUserLoaded(events?.onUserLoaded);
  if (events.onUserUnloaded) manager?.events.addUserUnloaded(events?.onUserUnloaded);
};

export const removeOidcEvents = (manager: UserManager | null, events: OidcEvents) => {
  if (events.onAccessTokenExpired)
    manager?.events.removeAccessTokenExpired(events.onAccessTokenExpired);
  if (events.onAccessTokenExpiring)
    manager?.events.removeAccessTokenExpiring(events?.onAccessTokenExpiring);
  if (events.onUserLoaded) manager?.events.removeUserLoaded(events?.onUserLoaded);
  if (events.onUserUnloaded) manager?.events.removeUserUnloaded(events?.onUserUnloaded);
};

export const useOidcEvents = (manager: UserManager | null, events: OidcEvents) => {
  React.useEffect(() => {
    addOidcEvents(manager, events);

    return () => {
      removeOidcEvents(manager, events);
    };
  }, [events, manager]);
};
